<template>
    <div class="modal" ref="modal">
        <transition name="zoom-in">
            <div v-if="isVisible" class="modal__container-wrapper">
                <div :class="clickOverlay" @click.stop="conditionalClose">
                    <div v-show="isVisible"
                        class="modal__container rounded-lg bg-grey-lighter"
                        :class="overflow ? 'modal__overflow' : ''"
                        tabindex="0"
                        role="dialog"
                        :aria-labelledby="ariaLabelledBy"
                        :aria-describedby="ariaDescribedBy">
                        <div class="modal__bar">
                            <button type="button" class="modal__close" @click="close">
                                <IconX />
                            </button>
                        </div>
                        <slot name="title"></slot>
                        <slot name="content" :close="close"></slot>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div v-show="isVisible" class="modal__overlay"></div>
        </transition>
    </div>
</template>

<script>
import focusTrap from 'focus-trap';
import IconX from 'icon/x.svg';

export default {
    name: 'modal',
    components: {
        IconX
    },
    props: {
        ariaLabelledBy: {
            type: String,
            required: false
        },
        ariaDescribedBy: {
            type: String,
            required: false
        },
        overlayClose: {
            type: Boolean,
            default: true
        },
        overflow: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        open() {
            this.isVisible = true;
            document.querySelector('body').classList.add('modal-is-open');
        },
        close() {
            this.isVisible = false;
            document.querySelector('body').classList.remove('modal-is-open');
            this.$emit('closeModal');
        },
        conditionalClose(e) {
            if (e.target.className === this.clickOverlay) {
                if (this.overlayClose) {
                    this.close();
                }
            }
        }
    },
    data() {
        return {
            isVisible: true,
            clickOverlay: 'modal__wrapper',
            modalFocusTrap: undefined
        };
    },
    mounted() {
        const modalContainer = this.$refs.modal;

        this.modalFocusTrap = focusTrap(modalContainer);

        document.addEventListener('keydown', (e) => {
            if (this.isVisible && e.keyCode === 27) {
                this.close();
            }
        });
    },
    created() {
        this.close();
    },
    updated() {
        this.$nextTick(() => {
            if (this.isVisible) {
                this.$el.querySelector('.modal__container-wrapper').focus();
                this.modalFocusTrap.activate();
            } else {
                this.modalFocusTrap.deactivate();
            }
        });
    }
};
</script>

<style scoped>

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.15s ease-in-out;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .zoom-in-enter-active, .zoom-in-leave-active {
        transition: all 0.2s ease-in-out;
    }

    .zoom-in-enter, .zoom-in-leave-to {
        opacity: 0;
        transform: scale(0.93);
    }

    .modal-is-open {
        overflow: hidden;
    }

    .modal {
        position: absolute;
        z-index: 9997;
        top: 0;
        left: 0;
        width: 100%;
    }

    .modal__overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .6);
        -webkit-font-smoothing: subpixel-antialiased;
    }

    .modal__container-wrapper {
        display: table;
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100%;
        z-index: 9998;
    }

    .modal__wrapper {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .modal__container {
        display: inline-block;
        position: relative;
        top: 0;
        padding: 15px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        max-width: 95vw;
        max-height: 95vh;
        z-index: 9999;
    }

    .modal__overflow {
        overflow-y: visible;
    }

    .modal__bar {
        display: flex;
        justify-content: flex-end;
    }

    .modal__close {
        background: transparent;
        cursor: pointer;
        border: none;
    }

    .modal__close-icon {
        fill: currentColor;
        width: 14px;
        height: 14px;
        margin-top: 7px;
    }
</style>
